import { render, staticRenderFns } from "./EmbeddedSection.vue?vue&type=template&id=3498ff98&scoped=true"
import script from "./EmbeddedSection.vue?vue&type=script&lang=js"
export * from "./EmbeddedSection.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedSection.vue?vue&type=style&index=0&id=3498ff98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3498ff98",
  null
  
)

export default component.exports